module.exports = __webpack_public_path__ + "img/bg.9fe50bc2.png";